import { ComponentDescriptor } from './component-descriptor';
import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class DynamicComponentInjectorService {
    private _subject$: Subject<ComponentDescriptor<any, any>> =
        new Subject<ComponentDescriptor<any, any>>();

    public get injector(): Observable<ComponentDescriptor<any, any>> {
        return this._subject$.asObservable();
    }

    public constructor() {}

    public load(component: ComponentDescriptor<any, any>): void {
        this._subject$.next(component);
    }

    public unload(container: string = null): void {
        this._subject$.next({
            component: null,
            container: container,
            context: null,
        });
    }
}
